import React, { useEffect } from "react";
import { useState, createContext,useMemo } from "react";
import Container from "react-bootstrap/Container";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import "./tablebooking.scss";
import { connect } from "react-redux";
import "./tablebookingpayment.scss";
import { useContext } from "react";
// import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import DINING from "./img/Dining-offers.png";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
// import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import ThemeContext from "../../common/theme/components/contexts/themecontexts";
import CardImg from "./img/cardNew.png";
import TickMarkImage from "./img/tickmark.png";
// import ConfirmIMg from "./img/Confirmed.svg";
import { IoChevronBack } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { getMainTableBooking } from "../../actions/home/mainTableBookingAction";
import { getTableGalleryDetail } from "../../actions/menu/tablegalleryAction";
// import CHECK from "./img/check.png";
// import { useHistory } from 'react-router-dom';

import { Helmet } from "react-helmet"; // Import necessary icons
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Pagination } from "swiper";
import { OrderFlow } from "../../App";

export const CheckoutContext = createContext({});
export const CheckoutData = () => useContext(CheckoutContext);

// accordian
// function ContextAwareToggle({ children, eventKey, callback }) {
//   const { activeEventKey } = useContext(AccordionContext);

//   const decoratedOnClick = useAccordionButton(
//     eventKey,
//     () => callback && callback(eventKey)
//   );

//   const isCurrentEventKey = activeEventKey === eventKey;

//   return (
//     <button
//       type="button"
//       className={`acco-btn-checkout ${isCurrentEventKey && "active"}`}
//       onClick={decoratedOnClick}
//     >
//       {children}
//     </button>
//   );
// }





function UserDetail() {
  const takeawayName = localStorage.getItem("clientName") || "";
  const takeawayorderpostcode = localStorage.getItem("orderPostcode") || "";

  const getLocalStorageData = () => {
    const storedData = localStorage.getItem("tableBookingAllData");
    if (storedData) {
      return JSON.parse(storedData);
    }
    console.error("No table booking data found in localStorage");
    return null;
  };
  const bookingData = getLocalStorageData();
 const tablelogo ="https://fusionbucket.co.uk/TableGalleryImages/fi_3567197.png";
 const timelogo = "https://fusionbucket.co.uk/TableGalleryImages/fi_3239945.png";
 const guestnumberlogo = "https://fusionbucket.co.uk/TableGalleryImages/Group 1171280422.png";
 const locationlogo = "https://fusionbucket.co.uk/TableGalleryImages/fi_1008001.png";

  return (
    <div className="restaurentUI">
      <div>
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex justify-content-center align-items-end ">
            <div>
              <img
                src={tablelogo}
                alt="kitchen logo"
                className="tablebookingimagelogo"
                // style={{ height: 80 }}
              />
              {/* <MdTableBar  style={{ height: 80 }} /> */}
            </div>
            <div className="tablepaytitle">
              <h5 style={{marginLeft:"10px"}}>{takeawayName}</h5>
              <p>{takeawayorderpostcode}</p>
            </div>
          </div>
          <div>
            {/* <p className="editables" onClick={handleNavClicktoback}>
              Edit
            </p> */}
          </div>
        </div>
        <hr className="line" />
        <div className="d-flex justify-content-between flex-wrap mt-3">
          <div className="d-flex justify-content-center align-items-end mb-2">
            <img src={timelogo} className="custdetailsimg" alt="" />
            {/* <GoClockFill className="custdetailsimg" /> */}
            <h5 className="custdetails">{bookingData.date}   {bookingData.time}</h5>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-end mb-2">
              <img src={guestnumberlogo} className="custdetailsimg" alt="" />
              {/* <IoPeople  className="custdetailsimg" /> */}
              <h5 className="custdetails">Number of Guests:</h5><span className="custdetailsspan">{bookingData.people}</span>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-end mb-2">
              <img src={locationlogo} className="custdetailsimg" alt="" />
              {/* <HiLocationMarker className="custdetailsimg" /> */}
              <h5 className="custdetails">{takeawayName}{takeawayorderpostcode}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// function Offer() {
//   return (
//     <div className="restaurentUI">
//       <div>
//         <div className="d-flex justify-content-between mb-3">
//           <div
//             className="d-flex justify-content-center align-items-end"
//           >
//             <div>
//               <h5 className="offertitle">Gold Offer Flat 25% OFF</h5>
//             </div>
//           </div>
//           <div>
//             <p className="editables"></p>
//           </div>
//         </div>
//         <hr className="dotted" />
//         <p className="address">
//           Pay bill through fusion app between 12:30 Am,19 <br /> Sep - 4:30.
//         </p>
//         <p className="editables1">More details </p>
//       </div>
//     </div>
//   );
// }

// function Occasion() {
//   return (
//     <div className="restaurentUI">
//       <div>
//         <div
//           className="d-flex justify-content-between
//          mb-1"
//         >
//           <div className="d-flex justify-content-center align-items-baseline">
//             <div className="occasion">
//               <h5 className="custdetails">Special Request</h5>
//               <Row>
//                 <Col xxl={12} xl={12} style={{ padding: "10px" }}>
//                   <InputGroup className="mb-3">
//                     <Form.Control
//                       placeholder="Special Request"
//                       aria-describedby="basic-addon2"
//                     />
//                     <Button variant="outline-secondary" id="button-addon2">
//                       Add Request
//                     </Button>
//                   </InputGroup>
//                 </Col>
//               </Row>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

function PaymentUI() {
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;
  const stripe = useStripe();
  const navigate = useNavigate();
  const elements = useElements();
  const [paymentTab, setPaymentTab] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [dinerDetails, setDinerDetails] = useState({});
  const [depositDetail, setDepositDetail] = useState(null);
  const [depositAmount, setDepositAmount] = useState("0.00");
  const [paymentMId, setPaymentMId] = useState("");
  const [payType, setPayType] = useState("");
  const [payBtnLoader, setPayBtnLoader] = useState(false);
  const [payBtnSuccess, setPayBtnSuccess] = useState(false);
  const [cardErrorMessage, setCardErrorMessage] = useState("");
  const [paymentIntentId, setPaymentIntentId] = useState("");
  // const history = useHistory();
  // Fetch and parse localStorage data
  const { loginPopupShow, setLoginPopupShow } =
    OrderFlow();
  // const handleShow = () => {
  //   setCurrentPage("signIn");
  //   setLoginPopupShow(true);
  // };
  const getLocalStorageData = () => {
    const storedData = localStorage.getItem("tableBookingAllData");
    if (storedData) {
      return JSON.parse(storedData);
    }
    console.error("No table booking data found in localStorage");
    return null;
  };

  const bookingData = getLocalStorageData();
  const depostAmountdetails = localStorage.getItem("original_deposit");

  // Calculate deposit amount based on booking data
  useEffect(() => {
    if (bookingData) {
      setDinerDetails({
        firstname: bookingData.firstname || "",
        lastname: bookingData.lastname || "",
        phone: bookingData.phone || "",
        email: bookingData.email || "",
        notes: bookingData.notes || "",
      });

      const simulatedDepositDetail = {
        amount: depostAmountdetails,
        perPerson: true,
        isActive: 1,
      };

      setDepositDetail(simulatedDepositDetail);

      if (simulatedDepositDetail && simulatedDepositDetail.isActive === 1) {
        const peopleCount = parseInt(bookingData.people.split(" ")[0], 10) || 1;
        const depositValue = simulatedDepositDetail.perPerson
          ? (simulatedDepositDetail.amount * peopleCount).toFixed(2)
          : simulatedDepositDetail.amount.toFixed(2);
        setDepositAmount(depositValue);
      }
    }
  }, [bookingData, depostAmountdetails]);
  const handleCheckStatus = () => {
    const loginCheck = localStorage.getItem("isLoggedIn");

    if (loginCheck === "true") {
      redirectToBooking();
    } else {
      setModalShow(false);
      setLoginPopupShow(true);
    }
  };

  const redirectToBooking = () => {
    if (width > breakpoint) {
      navigate("/myaccount/tablebooking"); // Desktop view
    } else {
      navigate("/tablebooking"); // Mobile view
    }
  };

  useEffect(() => {
    if (loginPopupShow) {
      const interval = setInterval(() => {
        const loginCheckAgain = localStorage.getItem("isLoggedIn");
        if (loginCheckAgain === "true") {
          setLoginPopupShow(false); // Close popup
          clearInterval(interval); // Stop checking
          redirectToBooking(); // Redirect user
        }
      }, 1000); // Check every second

      return () => clearInterval(interval); // Cleanup interval
    }
  }, [loginPopupShow]);
  const handlePaymentsSubmit = async (e) => {
    e.preventDefault();

    setCardErrorMessage(""); // Clear previous errors

    try {
      // Step 1: Create a payment method using Stripe
      const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements?.getElement(CardNumberElement),
      });

      if (stripeError) {
        setCardErrorMessage(stripeError.message);
        return;
      }

      // Set payment method ID and type for processing
      setPaymentMId(paymentMethod.id);
      setPayType("paymentMethodId");

      // Directly call the payment processing function
      await processPayment(paymentMethod.id, "paymentMethodId");
    } catch (error) {
      setCardErrorMessage(error.message || "An error occurred");
    }
  };

  const processPayment = async (paymentId, paymentType) => {
    setPayBtnLoader(true); // Start the loader

    const apiUrl = "https://api-new.fusionkitchen.co.uk/bookTableForNow";
    const requestData = {
      domain: window.location.hostname,
      date: bookingData.date,
      time: bookingData.time,
      people: bookingData.people,
      total: depositAmount,
      status: 1,
      payment: paymentType,
      [paymentType === "paymentMethodId" ? "paymentMethodId" : "paymentIntentId"]: paymentId,
      ...dinerDetails,
    };

    try {
      // Step 2: Make API call to process payment
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      console.log("API Response:", data);

      if (data.status) {
        if (data.type === "3dSecure") {
          // Step 3: Handle 3D Secure
          setPaymentIntentId(data.message.id); // Store Payment Intent ID
          const result = await stripe.confirmCardPayment(data.message.clientSecret);

          if (result.error) {
            setCardErrorMessage(result.error.message);
            setPayBtnLoader(false);
          } else {
            // Confirm payment after 3D Secure
            console.log("3D Secure confirmed:", result);
            setPayType("paymentIntentId");
            await processPayment(data.message.id, "paymentIntentId"); // Retry booking with Payment Intent ID
          }
        } else if (data.message === "Table Booked") {
          // Handle successful table booking
          finalizeBooking();
          elements.getElement(CardNumberElement)?.clear();
          elements.getElement(CardExpiryElement)?.clear();
          elements.getElement(CardCvcElement)?.clear();
        } else {
          setCardErrorMessage(data.message || "Unknown error");
        }
      } else {
        setCardErrorMessage(data.message || "Booking failed");
      }
    } catch (error) {
      setCardErrorMessage(error.message || "An error occurred");
    } finally {
      setPayBtnLoader(false); // Stop the loader
    }
  };

  // Finalize the booking and show the success modal
  const finalizeBooking = () => {
    setPayBtnSuccess(true); // Indicate success
    setModalShow(true); // Show success modal
    setCardErrorMessage(""); // Clear error messages
  };



  // useEffect(() => {
  //   processPayment();
  // }, [paymentMId, payType]);
  const { theme } = useContext(ThemeContext);
  const takeawayName = localStorage.getItem("clientName") || "";
  // const takeawayorderpostcode = localStorage.getItem("orderPostcode") || "";

  const handleBookingSubmit = async () => {
    setPayBtnLoader(true);

    const apiUrl = "https://api-new.fusionkitchen.co.uk/bookTableForNow";
    const requestData = {
      domain: window.location.hostname,
      date: bookingData.date,
      time: bookingData.time,
      people: bookingData.people,
      status: 1,
      ...dinerDetails,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (data.status) {
        setPayBtnSuccess(true);
      } else {
        setCardErrorMessage(data.message || "Booking failed.");
      }
    } catch (error) {
      console.error("Error booking table:", error);
      setCardErrorMessage("An error occurred while booking.");
    } finally {
      setPayBtnLoader(false);
    }
  };

  const bookingDate = new Date(bookingData.date); // Assuming bookingData.date is in "YYYY-MM-DD" format
  const formattedDate = bookingDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
  }); // Formats date like "30 January"

  // const formattedTime = new Date(`1970-01-01T${bookingData.time}:00`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // Formats time like "8:30 AM"
  const handleNavClicktoback = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <>
      {paymentTab ? (<div className="text-center">
        <Button
          className="table-button"
          onClick={handleBookingSubmit}
          disabled={payBtnLoader || payBtnSuccess}
        >
          {payBtnLoader ? (
            <>
              Booking... <Spinner animation="border" size="sm" />
            </>
          ) : (
            "Confirm Booking"
          )}
        </Button>
        {cardErrorMessage && <div className="text-danger mt-2">{cardErrorMessage}</div>}
      </div>) : (
        <div className="restaurentUIpay">
          <div className="d-flex overflow-auto">
            <button
              className="paymentcard d-flex justify-content-center align-items-center"
            >
              <img src={CardImg} alt="Card" className="cardimage" />

              <img
                src={TickMarkImage}
                alt="Tick Mark"
                className="tickMarkImage"
              />
            </button>
          </div>
          <Form onSubmit={handlePaymentsSubmit} className="form-label mb-3">
            <div className="payment-details">
              <Row className="align-items-center">
                <Col xxl={12}>
                  <h3 className="paymenttext">
                    {depositDetail && depositDetail.isActive === 1 ? (
                      <>
                        Pay Advance{" "}
                        {depositDetail.perPerson
                          ? `(£${depositDetail.amount}) per person`
                          : `(£${depositDetail.amount}) per booking`}
                      </>
                    ) : (
                      "No advance payment required"
                    )}
                  </h3>
                </Col>
                <Row>
                  <Col xxl={6} xl={6}>
                    <Form.Label className="form-label-styling">Card Number</Form.Label>
                    <CardNumberElement options={{ showIcon: true }} className="inputfeild-tablebooking" />
                  </Col>
                  <Col xxl={3} xl={3}>
                    <Form.Label className="form-label-styling">Expires on</Form.Label>
                    <CardExpiryElement className="inputfeild-tablebooking" />
                  </Col>
                  <Col xxl={3} xl={3}>
                    <Form.Label className="form-label-styling">Security Code</Form.Label>
                    <CardCvcElement className="inputfeild-tablebooking" />
                  </Col>
                  {cardErrorMessage && <span className="text-danger mt-2">{cardErrorMessage}</span>}
                </Row>
              </Row>
            </div>
            <button type="submit" disabled={payBtnLoader || payBtnSuccess} className="table-buttons" size="lg">
              {payBtnLoader ? (
                <>
                  Processing... <Spinner animation="border" size="sm" />
                </>
              ) : (
                `Pay £${depositAmount} to Confirm your Seat`
              )}
            </button>
          </Form>
        </div>
      )}

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        fullscreen="sm-down"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // className=""
        className={`custom-modal ${theme === "dark" ? "dark-theme" : ""}`}
      >
        {/* <Modal.Dialog style={{ maxWidth: '600px', margin: '0 auto' }}> */}{" "}
        <Modal.Header
          style={{
            width: "100%",
            position: "absolute",
            bottom: "78%",
            border: "none",
          }}
          className="cust-title"
        >
          <Modal.Title className="custom-title">
            <div className="badgess ">
              <div className="badgeschild">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 137 137"
                  fill="none"
                >
                  <g opacity="0.01">
                    <path
                      d="M68.1708 0.658203C30.5209 0.658203 0 31.1795 0 68.8294C0 106.479 30.5209 137 68.1708 137C105.821 137 136.342 106.479 136.342 68.8294C136.342 31.1795 105.821 0.658203 68.1708 0.658203Z"
                      fill="#66CE1C"
                    />
                  </g>
                  <path
                    d="M68.1703 17.573C39.8621 17.573 16.9141 40.5213 16.9141 68.8295C16.9141 97.1377 39.8621 120.086 68.1703 120.086C96.4785 120.086 119.427 97.1377 119.427 68.8295C119.427 40.5213 96.4785 17.573 68.1703 17.573Z"
                    fill="#173303"
                  />
                  <g opacity="0.05">
                    <path
                      d="M68.1703 17.573C39.7295 17.6354 16.8927 40.5647 16.9141 68.8295C16.9383 94.8271 35.993 116.016 60.9321 119.563C63.2957 119.9 65.7122 120.077 68.1703 120.086C94.7197 120.115 116.232 97.848 116.255 68.8684C116.277 39.9342 94.6999 17.5682 68.1703 17.573Z"
                      fill="white"
                    />
                  </g>
                  <path
                    d="M42.626 70.3052L58.643 86.046L94.2669 50.9744"
                    stroke="#9EE76F"
                    strokeWidth="8"
                  />
                </svg>
                <h4 className="paymenticon text-center">
                  Booking Confirmation
                </h4>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body  className="modalcontentbody">
          <div className="model-body popupdetails d-none d-sm-block">
            <h5 className="usertitle">
              {" "}
              {takeawayName} your booking has been confirmed
            </h5>
            <hr />

            <div className="d-flex justify-content-around flex-wrap ">
              <div>
                <h5 className="offertitle">
                  <b>Address:</b>
                </h5>
                <h6 className="custdetails">{bookingData.firstname}  {bookingData.lastname}</h6>
                <p className="address">
                  <br /> <br />{" "}
                </p>
                <h6 className="details">
                  <b>Number of Dinners: {bookingData.people} people</b>
                </h6>
                <h6 className="details">
                  {" "}
                  <b>Mobile : {bookingData.phone}</b>
                </h6>
                <h6 className="details">
                  {" "}
                  <b>Email : {bookingData.email}</b>
                </h6>
              </div>
              <div>
                <div className="buttons">
                  <span className="content">
                    <h2>{bookingDate.getDate()}</h2>
                    <h4>{formattedDate.split(" ")[1]}</h4> {/* Month */}
                    <h4>{bookingData.time}</h4>
                    <hr />
                    <h4>Ref No:</h4>
                    <h4>DRW2023</h4>
                  </span>
                  <span className="badges">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_6151_1906)">
                        <path
                          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                          fill="url(#paint0_linear_6151_1906)"
                        />
                        <path
                          d="M32.2594 16.0166C32.1215 15.5923 31.7549 15.2831 31.3135 15.219L24.222 14.1885L21.0506 7.76258C20.8532 7.36258 20.4458 7.10938 19.9997 7.10938C19.5537 7.10938 19.1463 7.36258 18.9489 7.76266L15.7775 14.1886L8.686 15.2191C8.24459 15.2832 7.87779 15.5924 7.73998 16.0166C7.60217 16.4409 7.71717 16.9066 8.03654 17.2179L13.168 22.2198L11.9566 29.2826C11.8812 29.7222 12.0619 30.1666 12.4228 30.4288C12.7837 30.6909 13.2621 30.7255 13.6569 30.518L19.9997 27.1834L26.3426 30.518C26.7404 30.727 27.2185 30.689 27.5767 30.4288C27.9376 30.1666 28.1183 29.7223 28.043 29.2826L26.8315 22.2198L31.963 17.2179C32.2823 16.9065 32.3972 16.4408 32.2594 16.0166Z"
                          fill="url(#paint1_linear_6151_1906)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_6151_1906"
                          x1="20"
                          y1="40"
                          x2="20"
                          y2="0"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FD5900" />
                          <stop offset="1" stopColor="#FFDE00" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_6151_1906"
                          x1="19.9997"
                          y1="30.6526"
                          x2="19.9997"
                          y2="7.10938"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FFE59A" />
                          <stop offset="1" stopColor="#FFFFD5" />
                        </linearGradient>
                        <clipPath id="clip0_6151_1906">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="d-block d-md-none d-sm-none">
            <div
              className="d-block d-sm-none primarycards"
              style={{ width: "100%", border: "none" }}
            >
              {/* <div className="custom-card-header d-flex justify-content-between align-items-center">
            <div>
              <FaArrowLeft  />
            </div>
            <div className="mobileback">
              <IoChevronBack
            onClick={() => setModalShow(false)}
                style={{ color: "#000" }}
              />
            </div>
            <div className="text-center flex-grow-1 text-right">
              <h5>Book a Seat</h5>
            </div>
          </div> */}
              <div className="d-flex gap-3 " style={{ margin: "10px" }}>
                <div className="mobileback">
                  <IoChevronBack
                    onClick={handleNavClicktoback}
                    style={{ color: "#000" }}
                  />
                </div>
                <div className="gap-4">
                  <h5 >Request Received</h5>
                </div>
              </div>
              <div>
                <div className="text-center custom-title-header">
                  {takeawayName}
                </div>


                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Reservation Details
                </div>
              </div>
              <div className="text-center" style={{ padding: "10px" }}>
                <h5> Booking Confirmed</h5>
                {/* <img src={ConfirmIMg} alt="" /> */}
              </div>
            </div>
            <UserDetail />
            {/* <Occasion /> */}
            {/* <Offer /> */}
          </div>
        </Modal.Body>
        <hr className="line" />
        <Modal.Footer className="status-button">
          <button onClick={handleCheckStatus}>Check status</button>
        </Modal.Footer>
        {/* </Modal.Dialog> */}
      </Modal>
    </>
  );
}
function Cardmobileview() {
  const { handleBookSeatClick } =
    OrderFlow();
  const booknowLink = `/${localStorage.getItem("clientPath")}/tablebook`;
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (location.pathname.includes("/tablebook")) {
  //     setShowBookingForm(true);
  //   }
  // }, [location.pathname, setShowBookingForm]);

  const handleNavClicktoback = () => {
    handleBookSeatClick();
    navigate(booknowLink);
  };


  return (
    <div
      border="primary"
      style={{ width: "100%", border: "none" }}
    >
      <div >
        <div className="d-flex gap-3" style={{ margin: "10px" }}>
          <div className="mobileback">
            <IoChevronBack
              onClick={handleNavClicktoback}
              style={{ color: "#000" }}
              className="mobileback"
            />
          </div>
          <div className="newdetails">
            <h5>Review Reservation Details</h5>
          </div>
        </div>
      </div>
    </div>
  );
}


function Tablebookpayment({getTableGalleryDetail,tablegalleryresponse}) {
  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;
  const takeawayName = localStorage.getItem("clientName") || "";
  // const takeawayorderpostcode = localStorage.getItem("orderPostcode") || "";


  // const handleUISelection = (ui) => {
  //   setSelectedUI(ui);
  // };
  // const styles = {
  //   fontFamily: "Poppins",
  //   fontWeight: 500,
  //   lineHeight: "31px",
  //   fontSize: "20px",
  //   color: "#214357", // Assuming this color is applied to all elements
  // };
  const getLocalStorageData = () => {
    const storedData = localStorage.getItem("tableBookingAllData");
    if (storedData) {
      return JSON.parse(storedData);
    }
    console.error("No table booking data found in localStorage");
    return null;
  };

  const bookingData = getLocalStorageData();
 const { path } = useParams();
   const formDatatablegallery = useMemo(() => {
     return {
       client_path: path,
       domain: window.location.hostname,
     };
   }, [path]);
   useEffect(() => {
     getTableGalleryDetail(formDatatablegallery);
   }, [getTableGalleryDetail, formDatatablegallery]);
   const tablebookimage360 = tablegalleryresponse?.Data?.tablegallery;
   const tableGalleryData = tablegalleryresponse?.Data;



  return (
    <div id="tablebookpayment">
      <Helmet>
        <style>
          {`
            @media (max-width: 480px) {
              nav.main-header{
                display: none ;
              }
              footer{
                display:none;
              }
                .top-to-btm{
                 display:none;
                 }
            }
          `}
        </style>
      </Helmet>
      {width > breakpoint ? (<section className="menu-section">
        <Container>
          <Row>
            <Col xs={12} sm={12} md={7} lg={8} xl={8} xxl={8}>
              <p className="tablebookpaytitle d-none d-sm-block">
                {takeawayName} and Confirm Reservation Details
              </p>

              <UserDetail />
              <div className="restaurentUI">
                <div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <h5 className="custdetails">Personal Details</h5>
                    </div>
                    <div>
                      <p className="editables"></p>
                    </div>
                  </div>
                  <hr className="dotted" />
                  <h5 className="custdetails">{bookingData.firstname} {bookingData.lastname}</h5>
                  <address className="address">
                    {bookingData.email} ,{bookingData.phone} <br />
                    {bookingData.notes}
                  </address>
                </div >
              </div>
              {/* <Occasion /> */}
              {/* <Offer /> */}
              <p className="tablebookpaytitle">Select Payment Method</p>
              <PaymentUI />
              {/* <div className="button-container">
                <Link
                  to="/tablebookingpayment"
                  style={{ textDecoration: "none" }}
                >
                  <button
                    className="table-buttons"
                    size="lg"
                    // onClick={GoBackFunction}
                    onClick={() => setModalShow(true)}
                  >
                    Confirm Your Seat
                  </button>
                </Link>
              </div> */}
            </Col>
            <Col xs={12} sm={12} md={5} lg={4} xl={4} xxl={4}>
              <div
                style={{
                  // background: "#ccc",
                  borderRadius: "11px",
                  // height: "204px",
                  marginTop: "30px",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // background: "#ccc",
                      position: "relative",
                      borderRadius: "11px",
                      height: "auto",
                      // marginBottom: "32px",
                    }}
                    className="dining-img"
                  >
                    <div className="d-none ">
                      <img src={DINING} alt="" />
                    </div>
                    <p className="paragraph d-none ">
                      Select your preferred time slot and we will get you the
                      best offers at this restaurant
                    </p>
                    {/* <div>
                      <div
                        className={
                          selectedUI === "discountUI"
                            ? "discountUI"
                            : "discountUI2"
                        }
                        onClick={() => handleUISelection("discountUI")}
                      >
                        <div>
                          <img
                            src={SaleImg}
                            alt=""
                            style={{ margin: "0", maxWidth: "100%" }}
                          />
                        </div>
                        <div className="offertext">
                          <p>
                            <b>20% flat OFF on bill</b> <br />
                          </p>
                          <p className="bookingFeeText">
                            Booking fee: £5 per Person
                          </p>
                        </div>
                        {selectedUI === "discountUI" && <GrCheckmark />}
                      </div>
                      <div
                        // style={{}}
                        className={
                          selectedUI === "discountUI2"
                            ? "discountUI"
                            : "discountUI2"
                        }
                        onClick={() => handleUISelection("discountUI2")}
                      >
                        <div>
                          <img
                            src={FKLOGO}
                            alt=""
                            style={{ margin: "0", maxWidth: "100%" }}
                          />
                        </div>
                        <div className="offertext">
                          <p>
                            <b>Gold offer 25% flat OFF on bill</b> <br />
                          </p>
                          <p className="bookingFeeText">
                            No Booking fee applicable
                          </p>
                        </div>
                        {selectedUI === "discountUI2" && <GrCheckmark />}
                      </div>
                    </div> */}
                  </div>
                  <div className="order-btn d-none d-sm-block">
                    {/* <button
                      style={{ width: "100%" }}
                      onClick={() => setModalShow(true)}
                    >
                      Confirm Your Seat
                    </button> */}
                  </div>
                </div>
                <div className="slider-content">
                  <div
                    className="d-none d-sm-block"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h4>Our food & Ambience Gallery</h4>
                    <p>
                      Reserve tables & manage your Reservations right from your
                      phone!
                    </p>
                  </div>

                  <div className="Slider-section d-none d-sm-block">
                    <div
                      style={{
                        // overflow: "hidden",
                        // height: "330px",
                        borderRadius: "20px",
                      }}
                    >
                      <Card id="imgcard">
                        <Swiper
                          slidesPerView={"auto"}
                          spaceBetween={30}
                          pagination={{
                            clickable: true,
                          }}
                          modules={[Pagination]}
                          className="mySwiper"
                          style={{ padding: "0px", backgroundColor: "none !important" }}
                          autoplay={{ delay: 1000 }}
                        >
                          {tablebookimage360?.[0]?.full_img === "0"
                            ? tablebookimage360.map((image, index) => (
                              <SwiperSlide key={index} className="swiper-slide-custom" style={{ padding: "0px" }}>
                                <img src={image.img} alt="tablebooking360img" />
                              </SwiperSlide>
                            ))
                            : [0, 1, 2, 3, 4, 5].map((_, index) => (
                              <SwiperSlide key={index} className="swiper-slide-custom" style={{ padding: "0px" }}>
                                <img src={tableGalleryData?.tablegallery?.[0]?.img} alt="tablegalleryimg"  />
                              </SwiperSlide>
                            ))}
                        </Swiper>
                      </Card>
                      <p
                        className="text-center"
                        style={{ padding: "10px", textDecoration: "underline", cursor: "pointer" }}
                      >
                        <Link to="/termsandcondition" style={{ textDecoration: "none", color: "inherit" }}>
                          <b>Terms & Conditions</b>
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

        </Container>
      </section>) : (<section className="menu-section">
        <Container>
          <Row>
            <Col xs={12} sm={12} md={7} lg={8} xl={8} xxl={8}>
              <Cardmobileview />
              <p className="tablebookpaytitle d-none d-sm-block">
                {takeawayName} and Confirm Reservation Details
              </p>
              <UserDetail />
              <div className="restaurentUI">
                <div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <h5 className="custdetailsperson">Personal Details</h5>
                    </div>
                    <div>
                      <p className="editables"></p>
                    </div>
                  </div>
                  <hr className="dotted" />
                  <h5 className="custdetailsperson">{bookingData.firstname} {bookingData.lastname}</h5>
                  <address className="address">
                    {bookingData.email} ,{bookingData.phone} <br />
                    {bookingData.notes}
                  </address>
                </div >
              </div>
              {/* <Occasion /> */}
              {/* <Offer /> */}
              <p className="tablebookpaytitle">Select Payment Method</p>
              <PaymentUI />
              {/* <div className="button-container">
                <Link
                  to="/tablebookingpayment"
                  style={{ textDecoration: "none" }}
                >
                  <button
                    className="table-buttons"
                    size="lg"
                    // onClick={GoBackFunction}
                    onClick={() => setModalShow(true)}
                  >
                    Confirm Your Seat
                  </button>
                </Link>
              </div> */}
            </Col>
            {/* <Col xs={12} sm={12} md={5} lg={4} xl={4} xxl={4}>
              <div
                style={{
                  // background: "#ccc",
                  borderRadius: "11px",
                  // height: "204px",
                  marginTop: "30px",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // background: "#ccc",
                      position: "relative",
                      borderRadius: "11px",
                      height: "auto",
                      // marginBottom: "32px",
                    }}
                    className="dining-img"
                  >
                    <div className="d-none ">
                      <img src={DINING} alt="" />
                    </div>
                    <p className="paragraph d-none ">
                      Select your preferred time slot and we will get you the
                      best offers at this restaurant
                    </p>
                    <div>
                      <div
                        className={
                          selectedUI === "discountUI"
                            ? "discountUI"
                            : "discountUI2"
                        }
                        onClick={() => handleUISelection("discountUI")}
                      >
                        <div>
                          <img
                            src={SaleImg}
                            alt=""
                            style={{ margin: "0", maxWidth: "100%" }}
                          />
                        </div>
                        <div className="offertext">
                          <p>
                            <b>20% flat OFF on bill</b> <br />
                          </p>
                          <p className="bookingFeeText">
                            Booking fee: £5 per Person
                          </p>
                        </div>
                        {selectedUI === "discountUI" && <GrCheckmark />}
                      </div>
                      <div
                        // style={{}}
                        className={
                          selectedUI === "discountUI2"
                            ? "discountUI"
                            : "discountUI2"
                        }
                        onClick={() => handleUISelection("discountUI2")}
                      >
                        <div>
                          <img
                            src={FKLOGO}
                            alt=""
                            style={{ margin: "0", maxWidth: "100%" }}
                          />
                        </div>
                        <div className="offertext">
                          <p>
                            <b>Gold offer 25% flat OFF on bill</b> <br />
                          </p>
                          <p className="bookingFeeText">
                            No Booking fee applicable
                          </p>
                        </div>
                        {selectedUI === "discountUI2" && <GrCheckmark />}
                      </div>
                    </div>
                  </div>
                  <div className="order-btn d-none d-sm-block">
                    <button
                      style={{ width: "100%" }}
                      onClick={() => setModalShow(true)}
                    >
                      Confirm Your Seat
                    </button>
                  </div>
                </div>
                <div className="slider-content">
                  <div
                    className="d-none d-sm-block"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h4>Our food & Ambience Gallery</h4>
                    <p>
                      Reserve tables & manage your Reservations right from your
                      phone!
                    </p>
                  </div>

                  <div className="Slider-section d-none d-sm-block">
                    <div
                      style={{
                        // overflow: "hidden",
                        // height: "330px",
                        borderRadius: "20px",
                      }}
                    >
                      <Card id="imgcard">
                        <Swiper
                          slidesPerView={"auto"}
                          spaceBetween={30}
                          pagination={{
                            clickable: true,
                          }}
                          modules={[Pagination]}
                          className="mySwiper"
                          autoplay={{ delay: 1000 }}
                          style={{ padding: "0px" }} // Adjust the delay as needed (in milliseconds)
                        >
                          <SwiperSlide className="swiper-slide-custom" style={{ padding: "0px" }}>
                            <img src={SLIDER} alt="slider" />
                          </SwiperSlide>
                          <SwiperSlide className="swiper-slide-custom" style={{ padding: "0px" }}>
                            <img src={SLIDER2} alt="slider" />
                          </SwiperSlide>
                          <SwiperSlide className="swiper-slide-custom" style={{ padding: "0px" }}>
                            <img src={SLIDER} alt="slider" />
                          </SwiperSlide>
                          Add more SwiperSlides with images
                        </Swiper>
                        <Card.Body>
                          <Card.Title
                            id="cardtitle"
                            style={{ textAlign: "center" }}
                          >
                            <FaEye /> Add photos
                          </Card.Title>
                        </Card.Body>
                      </Card>
                      <p
                        className="text-center"
                        style={{ padding: "10px", textDecoration: "underline", cursor: "pointer" }}
                      >
                        <Link to="/termsandcondition" style={{ textDecoration: "none", color: "inherit" }}>
                          <b>Terms & Conditions</b>
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col> */}
          </Row>

        </Container>
      </section>)}

    </div>
  );
}

const mapStateToProps = (state) => ({
  response: state.mainTableBooking?.response,
  tablegalleryresponse: state.tableBookGallery.response,
  tablegalleryisLoading: state.tableBookGallery,
  tablegalleryerror: state.tableBookGallery,
});

const mapDispatchToProps = {
  getMainTableBooking,
  getTableGalleryDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tablebookpayment);

